import { AvForm } from 'availity-reactstrap-validation'
import { useRef, useState } from 'react'

import RenderFields from '../../../CMSComponent/Forms/renderFields'
import { primary_color } from '../../../Helper/uiHelper'
import { useDispatch, useSelector } from 'react-redux'
import { clearCurrentRowData, clearParentTableData, fetchUpdateApiData } from '../../../Redux/Reducers/CMS'
import { request } from '../../../Redux/Sagas/requests/api'
import { isSuccessResponse } from '../../../helper'
import { Button } from 'reactstrap'
import RenewalEmailTemplatePreview from './renewalEmailTemplatePreview'
import { setNotification } from '../../../Redux/Reducers/notificationHandling'

const GoLiveEarly = ({ addFormList, addDataDetail, setAddGridDataDetail }) => {
  const saveNclose = useRef()
  const currentRow = useSelector((state) => state.CMS.currentRow)

  const [formFieldValue, setFormFieldValue] = useState(currentRow?.[1])
  const [defaultSingleFormValue, setDefaultSingleFormValue] = useState(currentRow?.[1])
  const [loading, setLoading] = useState(false)
  const [previewEmail, setPreviewEmail] = useState(false)

  const dispatch = useDispatch()

  const onCloseForm = () => {
    dispatch(fetchUpdateApiData())
    if (!addDataDetail?.isAddNew) {
      dispatch(clearCurrentRowData())
      dispatch(clearParentTableData())
    }
    setAddGridDataDetail({ open: false })
  }

  const onSave = (values) => {
    let payload = {
      parent_table_row_id: currentRow?.[0]?.id,
      parent_table: 'item_date_times',
      is_nested: true,
      data: {
        [addDataDetail?.tableGrid?.source_table]: [
          {
            id: defaultSingleFormValue?.id,
            ...values,
          },
        ],
      },
    }
    setLoading(true)
    request('domain-start-date-save', 'POST', payload).then((res) => {
      if (isSuccessResponse(res, 'Form submitted successfully!')) {
        setLoading(false)
        if (saveNclose.current) {
          onCloseForm()
        }
      }
    })
  }

  return (
    <div className='p-4 px-5'>
      <AvForm
        onValidSubmit={(e, values) => {
          onSave(values)
        }}>
        <RenderFields
          allForm={addFormList}
          content={addFormList}
          twoCol={true}
          defaultFormValue={defaultSingleFormValue}
          formFieldValue={formFieldValue}
          setFormFieldValue={setFormFieldValue}
          noCache={true}
        />
        <div className='d-flex justify-content-end mt-5'>
          {' '}
          <button
            className='btn rounded-pill mt-2 text-danger border-danger mr-3'
            type='button'
            id='close-btn'
            onClick={(e) => {
              onCloseForm()
              e.preventDefault()
              e.stopPropagation()
            }}
            style={{ fontWeight: 700, width: '12rem' }}>
            Close
          </button>
          <button
            className='btn text-white rounded-pill mt-2 mr-3'
            disabled={!!loading}
            type='submit'
            id='save-button'
            style={{ background: primary_color, fontWeight: 700, width: '14rem' }}>
            {loading ? 'Saving...' : 'Save'}
          </button>
          <button
            className='btn text-white rounded-pill mt-2 mr-3'
            disabled={!!loading}
            onClick={(e) => {
              e.stopPropagation()
              e.preventDefault()
              saveNclose.current = true
              const ele = document.getElementById('save-button')
              if (ele) {
                ele.click()
              }
            }}
            type='submit'
            style={{ background: primary_color, fontWeight: 700, width: '14rem' }}>
            Save & Close
          </button>
        
        </div>
      </AvForm>
    </div>
  )
}

export default GoLiveEarly
